export default __webpack_public_path__ + "static/dollarAdayUsaBanner-97f86cf0aacc59a41c8857fd2839df15.png";